import React from 'react';

import { Routes, Route } from 'react-router-dom';
import About from '../../pages/About';
import Contact from '../../pages/Contact';
import Home from '../../pages/Home';
import Menu from '../../pages/Menu';
import Recipe from '../../pages/Recipe';

const ConfigRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="menu" element={<Menu />} />
            <Route path="recipe" element={<Recipe />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
        </Routes>
    );
};

export default ConfigRouter;
